module.exports = __webpack_public_path__ + "static/assets/b46bb8edf6b8038789d27d8f7037ba27.svg";